import {Component, OnInit} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs/Rx';
import {NotificationService} from '../../services/notification.service';
import {SessionStorageService} from '../../services/session-storage.service';

@Component({
    selector: 'app-mattermost',
    templateUrl: './mattermost.component.html',
    styleUrls: ['./mattermost.component.scss']
})
export class MatterMostComponent implements OnInit {
    isLoggdedIn: boolean;
    materMostUser: any;
    channelData: any;
    team: any;
    users: Array<any>;
    channels: Array<any>;
    privateChannels: Array<any>;

    constructor(public notificationService: NotificationService, public sessionStorageService: SessionStorageService, public http: HttpClient) {
        this.isLoggdedIn = false;
        this.channelData = [];
        this.users = [];
        this.channels = [];
        this.privateChannels = [];
        this.initMatterMostRequest('users/login', {
            login_id: 'chinjan@vetron.in',
            password: 'vetron23'
        }).subscribe((data: any) => {
            this.materMostUser = data;
            this.getTeam();
            console.log('materMostUser', this.materMostUser);
        });
    }

    ngOnInit() {
    }

    initMatterMostRequest(func: string, data: any) {
        const url = 'https://chat.szvetron.com/api/v4/';
        let header = new HttpHeaders();
        header = header.append('Content-Type', 'application/json');

        return this.http.post(url + func, data, {
            responseType: 'json',
            headers: header
        })
            .map((success: Object | any) => {
                return success;
            })
            .catch((errors: any) => {
                console.log('errors', errors);
                return Observable.throw(errors);
            });
    }

    postMM(func: string, token: string, data: any) {
        const url = 'https://chat.szvetron.com/api/v4/';
        let header = new HttpHeaders();
        header = header.append('Content-Type', 'application/json');
        header = header.append('Authorization', 'Bearer ' + token);

        return this.http.post(url + func, data, {
            responseType: 'json',
            headers: header
        })
            .map((success: Object | any) => {
                return success;
            })
            .catch((errors: any) => {
                console.log('errors', errors);
                return Observable.throw(errors);
            });
    }

    getMM(func: string, token: string) {
        const url = 'https://chat.szvetron.com/api/v4/';
        let header = new HttpHeaders();
        header = header.append('Content-Type', 'application/json');
        header = header.append('Authorization', 'Bearer ' + token);
        return new Promise((resolve: any) => {
            this.http.get(url + func, {headers: header})
                .retryWhen((error: any) => {
                    return error
                        .flatMap((errors: any) => {
                            if (errors.status === 500) {
                                return Observable.of(errors.status).delay(4000);
                            }
                            return Observable.throw({error: errors});
                        })
                        .take(1);
                })
                .subscribe((data: any) => {
                        resolve(data);
                    },
                    (err: any) => {
                        console.log('err', err);
                    }
                );
        });
    }

    getImage(func: string, token: string): Observable<Blob> {
        const url = 'https://chat.szvetron.com/api/v4/';

        let header = new HttpHeaders();
        header = header.append('Authorization', 'Bearer ' + token);
        return this.http.get(url + func, {headers: header, responseType: 'blob'});
    }

    createImageFromBlob(image: Blob, userDetail: any) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            userDetail['avtar'] = reader.result;
            this.users.push(userDetail);
        }, false);

        if (image) {
            reader.readAsDataURL(image);
        }
    }

    getChannelMessage(channelID: string) {
        this.getMM('users/' + this.materMostUser.id + '/channels/' + channelID + '/unread', 'mt4eajscmpg55q69xtyhatkjse').then((channelData: any) => {
            channelData['msg_count'] > 0
                ? this.getMM('channels/' + channelData['channel_id'] + '/members', 'mt4eajscmpg55q69xtyhatkjse').then((users: any) => {
                    const test = this.channels.find(channel_id => channel_id == channelData['channel_id']);
                    if (test == undefined) {
                        this.channels.push(channelData['channel_id']);
                        users.filter(user => user['user_id'] != this.materMostUser.id
                            ? this.getMM('users/' + user['user_id'], 'mt4eajscmpg55q69xtyhatkjse').then((userDetail: any) => {
                                userDetail['msg_count'] = channelData['msg_count'];
                                this.getImage('users/' + user['user_id'] + '/image', 'mt4eajscmpg55q69xtyhatkjse').subscribe((userImage: any) => {
                                    this.createImageFromBlob(userImage, userDetail);
                                }, () => this.users.push(userDetail));
                            })
                            : false);
                    }
                })
                : false;
        });
    }

    getPrivateChannelMessage(channel: Object) {
        this.getMM('users/' + this.materMostUser.id + '/channels/' + channel['id'] + '/unread', 'mt4eajscmpg55q69xtyhatkjse').then((channelData: any) => {
            channelData['msg_count'] > 0
                ? this.getMM('channels/' + channelData['channel_id'] + '/members', 'mt4eajscmpg55q69xtyhatkjse').then((users: any) => {
                    const test = this.privateChannels.find(channel_id => channel_id == channelData['channel_id']);
                    if (test == undefined) {
                        this.privateChannels.push(channel['id']);
                        channel['msg_count'] = channelData['msg_count'];
                        this.channelData.push(channel);
                    }
                })
                : false;
        });
    }

    getTeam() {
        this.getMM('users/' + this.materMostUser.id + '/teams', 'ttza8g5zwpb87xppgsbnfen3uw').then((team: any) => {
            this.team = team[0];
            this.getMM('/users/' + this.materMostUser.id + '/teams/' + this.team.id + '/channels', 'ttza8g5zwpb87xppgsbnfen3uw').then((teamData: Array<Object>) => {
                this.users = [];
                this.channelData = [];
                setInterval(() => {
                    teamData.filter((item) => item['type'] == 'P'
                        ? this.getPrivateChannelMessage(item)
                        : false);
                    teamData.filter((item) => item['type'] == 'D'
                        ? this.getChannelMessage(item['id'])
                        : false);
                }, 10000);
            });
        });
    }

    getUsers() {
        this.getMM('/users', 'ttza8g5zwpb87xppgsbnfen3uw').then((users) => {
            console.log('users', users);
        });
    }

    getPersonalMessage() {
        this.getMM('users/' + this.materMostUser.id + '/teams', 'ttza8g5zwpb87xppgsbnfen3uw').then((channelData: any) => {
            console.log('channelData', channelData);
            this.channelData = channelData;
        });
    }

}
